<template>
  <router-link
    :to="{ name: 'live.show', params: {id: live.id, slug: live.slug} }"
    class="live-schedule-thumb-box"
  >
    <BoxShadow>
      <div class="thumb-box">
        <div class="embed-responsive embed-responsive-16by9">
          <img :src="live.thumb_url" :alt="live.name" class="embed-responsive-item">
        </div>
        <span class="live-tag"><span>Live agendada</span></span>
      </div>
      <header class="content-spacing">
        <h2>{{ live.name }}</h2>
        <h3
          v-if="live.user"
        >por <b>{{ live.user.name }}</b></h3>
      </header>
      <div class="text-center divisor-box">
        <ContentDivisor />
      </div>
      <div class="date-box">
        <b class="date">{{ dateFormat }}</b>
        <div class="time">{{ timeFormat }}</div>
      </div>
    </BoxShadow>
  </router-link>
</template>

<script>
  import 'moment/locale/pt'
  import moment from 'moment'
  import BoxShadow from '@/components/boxes/BoxShadow'
  import ContentDivisor from '@/components/layout/ContentDivisor'

  export default {
    components: {
      BoxShadow,
      ContentDivisor
    },
    props: { live: { type: Object, default: () => ({}) } },
    computed: {
      dateFormat () {
        return moment(this.live.released_at).format('D [de] MMMM').toUpperCase()
      },
      timeFormat () {
        return moment(this.live.released_at).format('[às] H:mm[hrs]')
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .live-schedule-thumb-box {
    display: block;
    position: relative;
    // width: 290px;

    .divisor-box {
      margin-bottom: 10px;
    }

    .date-box {
      font-family: 'Poppins';
      text-align: center;
      margin-bottom: 20px;
      color: #6C6C6C;
    }

    h2 {
      color: #000;
      font-size: 1.125rem;
      font-weight: 600;
      margin-bottom: 10px;
      min-height: 40px;
    }

    h3 {
      font-size: 15px;
      color: #000;
    }

    .thumb-box {
      position: relative;

      .live-tag {
        display: inline-flex;
        position: absolute;
        bottom: -13.5px;
        border: 2px solid #fff;
        left: 50%;
        transform: translateX(-50%);
        align-items: center;
        justify-content: center;
        background: #f00;
        color: #fff;
        border-radius: 30px;
        font-size: 13px;
        font-family: 'Poppins';
        padding: 2px 10px;
        width: 150px;
        font-weight: 600;
        z-index: 5;

        span {
          flex-shrink: 0;
        }

        &:before {
          content: '';
          width: 6px;
          height: 6px;
          background: #fff;
          border-radius: 100%;
          margin-right: 8px;
          animation: blink 2s infinite;
          transition: .5s all;
          flex-shrink: 0;
        }
      }
    }
  }

  @keyframes blink {
    0% { opacity: 1 }
    33% { opacity: 1 }
    66% { opacity: 0 }
    100% { opacity: 1 }
  }
</style>